export const getGoogleMapUrl = (latitude, longitude) =>
  `https://www.google.com/maps/embed/v1/place?key=${process.env.NEXT_PUBLIC_GMAP_API_KEY_EMBED}&q=${latitude},${longitude}`;
